import { render, staticRenderFns } from "./planDetCopy.vue?vue&type=template&id=1b6145ca&scoped=true&"
import script from "./planDetCopy.vue?vue&type=script&lang=js&"
export * from "./planDetCopy.vue?vue&type=script&lang=js&"
import style0 from "./planDetCopy.vue?vue&type=style&index=0&id=1b6145ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6145ca",
  null
  
)

export default component.exports